import React, { useState } from 'react';
import { AppBar, Toolbar, Button, Typography, Box, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import { logout } from '../utils/auth';
import { useCustomer } from '../contexts/customer-context';

// Import your logo image
//import logoImage from "./Aviora-logo.png"; // Update this path to your actual logo file

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const { setCustomerId } = useCustomer();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditProfile = () => {
    navigate('/profile');
    handleClose();
  };

  const handleChangePassword = () => {
    navigate('/change-password');
    handleClose();
  };

  const handleSignOut = async () => {
    await logout();
    navigate('/login');
    handleClose();
  };

  const handleHome = () => {
    navigate('/welcome');
    handleClose();
  };

  const isProfilePage = location.pathname === '/profile';
  const isChangePasswordPage = location.pathname === '/change-password';

  const menuItems = [
    ...(isChangePasswordPage ? [{ label: 'Home', icon: <HomeIcon />, onClick: handleHome }] : []),
    {
      label: isProfilePage ? 'Home' : 'Edit Profile',
      icon: isProfilePage ? <HomeIcon /> : <EditIcon />,
      onClick: isProfilePage ? handleHome : handleEditProfile,
    },
    ...(isChangePasswordPage ? [] : [{ label: 'Change Password', icon: <LockIcon />, onClick: handleChangePassword }]),
    {
      label: 'Sign Out',
      icon: <ExitToAppIcon />,
      onClick: handleSignOut,
    },
  ];

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        {/* Replace the text with your logo image */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize: { xs: '1rem', sm: '1.25rem' }, display: 'flex', alignItems: 'center' }}>
          <img 
            src="./Aviora-logo.png" 
            alt="Your App Logo" 
            style={{ 
              height: '40px', // Adjust this value to fit your logo size
              marginRight: '10px' // Add some space between the logo and other elements
            }} 
          />
          {/* You can keep the text as a fallback or remove it entirely */}
          {/* Your App Name */}
        </Typography>
        {isMobile ? (
          <>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {menuItems.map((item, index) => (
                <MenuItem key={index} onClick={item.onClick}>
                  {item.icon}
                  <Typography variant="body1" sx={{ ml: 1 }}>
                    {item.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </>
        ) : (
          <Box sx={{ display: 'flex', gap: 2 }}>
            {menuItems.map((item, index) => (
              <Button
                key={index}
                color="inherit"
                startIcon={item.icon}
                onClick={item.onClick}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;

// Log for troubleshooting
console.log('Header component rendered');
